<template>
    <div class="space-y-6">
        <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 transition-all duration-200 ease-in-out">
            <div class="md:grid md:grid-cols-3 md:gap-6" v-if="state.saved && !state.coupon?.saved">
                <div class="md:col-span-1">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Discounts</h3>
                    <p class="mt-1 text-sm text-gray-500">Add an optional price adjustment</p>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <form class="space-y-6" method="POST" @submit.prevent>
                        <div>
                            <div class="flex justify-center mt-4">
                                <Listbox as="div" v-model="state.coupon" v-if="coupons" class="w-full">
                                    <div class="mt-1 relative w-full">
                                        <ListboxButton class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <span class="block truncate">{{ state.coupon?.name ?? 'Choose A Discount' }}</span>
                                            <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
                                            </span>
                                        </ListboxButton>

                                        <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                                            <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                                <ListboxOption as="template" v-for="coupon in coupons" :key="coupon.id" :value="coupon" v-slot="{ active, selected }">
                                                    <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
                                                        <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                                                            {{ coupon.name }}&nbsp;<span class="italic text-sm">({{ coupon.amount_off ? currencyFormat(coupon.currency, coupon.amount_off) : coupon.percent_off + '%' }} Off)</span>
                                                        </span>
                                                        <span v-if="selected" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                                            <CheckIcon class="h-5 w-5" aria-hidden="true"/>
                                                        </span>
                                                    </li>
                                                </ListboxOption>
                                            </ListboxOptions>
                                        </transition>
                                    </div>
                                </Listbox>
                            </div>


                            <div class="flex mt-4 justify-center">
                                <button type="submit" @click="proceed" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <ChevronDownIcon class="h-5 w-5 mr-2" />
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="md:grid md:grid-cols-3 md:gap-6" v-if="!state.saved || state.coupon?.saved">
                <div class="md:col-span-1 flex">
                    <CheckCircleIcon class="h-6 w-6 text-green-600 mr-4" v-if="state.coupon?.saved" />
                    <h3 class="text-lg font-medium leading-6 text-gray-900 flex-1">Discount</h3>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2" v-if="state.coupon?.saved">
                    <p class="font-normal text-md">{{ state.coupon.name }} Applied to Purchase</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from "@headlessui/vue"
import {CheckIcon, ChevronUpDownIcon, XMarkIcon} from "@heroicons/vue/24/solid"
import {CheckCircleIcon, ChevronDownIcon, EyeIcon, EyeSlashIcon, ArrowPathIcon} from "@heroicons/vue/24/outline"
import {ref, toRef, watch} from "vue"

export default {
    name: "Discounts",
    props: {
        product: {
            type: Object,
            required: true,
        }
    },
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ChevronUpDownIcon,
        ArrowPathIcon,
        XMarkIcon,
        ChevronDownIcon,
        EyeIcon,
        EyeSlashIcon,
        CheckCircleIcon,
    },
    setup(props) {
        const state = toRef(props, 'product')
        const coupons = ref(null);

        const getCoupons = async () => {
            let productId = state.value.price.product.id

            await axios.get(route('transactions.products.coupons', { productId: productId }))
                .then((response) => {
                    coupons.value = response.data
                })
        }

        const proceed = () => {
            state.value.coupon.saved = true
        }

        watch(() => state.value.saved, (saved) => {
            if (saved) {
                getCoupons()
            }
        }, {deep: true})

        return {
            state,
            coupons,
            proceed,
        }
    }
}
</script>

<style scoped>

</style>
